import React, { useState } from 'react';
import { Heart, CheckCircle, XCircle } from 'lucide-react';

export default function ConviteEvento() {
  const [etapa, setEtapa] = useState('inicial'); // inicial, confirmando, nao-posso, sucesso
  const [dados, setDados] = useState({
    nome: '',
    sobrenome: '',
    adultos: 1,
    criancas: 0,
    adolescentes: 0,
    status: ''
  });
  const [enviando, setEnviando] = useState(false);

  // IMPORTANTE: Cole aqui a URL do seu Google Apps Script
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwXTc7QWYSAymBCkjA0pNIK2r7-6nP6zBUUigBn3RMEoMjrM1dJT0FWgyog6-ojWrRT_A/exec';

  const enviarParaGoogleSheets = async () => {
    setEnviando(true);
    try {
      // eslint-disable-next-line no-unused-vars
      const resposta = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dados)
      });
      
      setEtapa('sucesso');
    } catch (erro) {
      console.error('Erro ao enviar:', erro);
      alert('Erro ao enviar. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  const handleConfirmar = () => {
    setDados({ ...dados, status: 'confirmado' });
    setEtapa('confirmando');
  };

const handleListaPresentes = () => {
  setEtapa('lista-presentes');
};

  const handleNaoPosso = () => {
    setDados({ ...dados, status: 'nao_pode' });
    setEtapa('nao-posso');
  };

  const handleSubmitConfirmacao = (e) => {
    e.preventDefault();
    if (!dados.nome.trim()) {
      alert('Por favor, digite seu nome');
      return;
    }
    enviarParaGoogleSheets();
  };

  const handleSubmitNaoPosso = (e) => {
    e.preventDefault();
    if (!dados.nome.trim() || !dados.sobrenome.trim()) {
      alert('Por favor, preencha nome e sobrenome');
      return;
    }
    enviarParaGoogleSheets();
  };

  // Tela Inicial
  if (etapa === 'inicial') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
          <div className="text-center mb-8">
         <img 
            src="/derek.png" 
            alt="Derek" 
            className="w-[150px] h-[150px] object-cover mx-auto mb-4 rounded-full"
          />       
            <Heart className="w-25 h-25 mx-auto text-pink-500 mb-4" />
            <h3 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Você está convidado!
            </h3>
            <div className="space-y-2 text-gray-600 text-lg">
              <p className="font-semibold">📅 Data: Terça-Feira, 9 de Dezembro de 2025</p>
              <p className="font-semibold">🕐 Horário: 19h00</p>
              <p className="font-semibold">📍 Local: Salão Fest Maranata</p>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-7 mb-7">
            <p className="text-center text-gray-700 text-lg mb-6">
              Gostaríamos muito da sua presença! 🎉
            </p>
          </div>

          <div className="space-y-4">
            <button
              onClick={handleConfirmar}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-3 text-lg shadow-lg"
            >
              <CheckCircle className="w-6 h-6" />
              Confirmo Presença
            </button>

            <button
              onClick={handleNaoPosso}
              className="w-full bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-3 text-lg shadow-lg"
            >
              <XCircle className="w-6 h-6" />
              Não Posso Ir
            </button>
            <button
                        onClick={handleListaPresentes}
                        className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-3 text-lg shadow-lg"
                        >
                        <CheckCircle className="w-6 h-6" />
                        Sugestões de presente
            </button>

            
          </div>
        </div>
      </div>
    );
  }

  // Tela de Confirmação
  if (etapa === 'confirmando') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
          <div className="text-center mb-8">
            <CheckCircle className="w-16 h-16 mx-auto text-green-500 mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              Que ótimo! 🎉
            </h2>
            <p className="text-gray-600 text-lg">
              Por favor, preencha as informações abaixo
            </p>
          </div>

          <form onSubmit={handleSubmitConfirmacao} className="space-y-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Seu Nome Completo *
              </label>
              <input
                type="text"
                value={dados.nome}
                onChange={(e) => setDados({ ...dados, nome: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:outline-none text-lg"
                placeholder="Digite seu nome completo"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Quantos adultos vão? * se for apenas você, selecione 1
              </label>
              <select
                value={dados.adultos}
                onChange={(e) => setDados({ ...dados, adultos: parseInt(e.target.value) })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:outline-none text-lg"
              >
                {[1, 2, 3].map(num => (
                  <option key={num} value={num}>{num} adulto{num > 1 ? 's' : ''}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Quantas crianças (0-12 anos)?
              </label>
              <select
                value={dados.criancas}
                onChange={(e) => setDados({ ...dados, criancas: parseInt(e.target.value) })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:outline-none text-lg"
              >
                {[0, 1, 2, 3].map(num => (
                  <option key={num} value={num}>{num} criança{num !== 1 ? 's' : ''}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Quantos adolescentes (13-17 anos)?
              </label>
              <select
                value={dados.adolescentes}
                onChange={(e) => setDados({ ...dados, adolescentes: parseInt(e.target.value) })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-purple-500 focus:outline-none text-lg"
              >
                {[0, 1, 2, 3].map(num => (
                  <option key={num} value={num}>{num} adolescente{num !== 1 ? 's' : ''}</option>
                ))}
              </select>
            </div>

            <div className="pt-4 space-y-3">
              <button
                type="submit"
                disabled={enviando}
                className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 text-lg shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {enviando ? 'Enviando...' : 'Confirmar Presença'}
              </button>

              <button
                type="button"
                onClick={() => setEtapa('inicial')}
                className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-all text-lg"
              >
                Voltar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Tela de Não Posso Ir
  if (etapa === 'nao-posso') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
          <div className="text-center mb-8">
            <XCircle className="w-16 h-16 mx-auto text-red-500 mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
              Que pena!, vamos sentir sua falta!! 😢
            </h2>
            <p className="text-gray-600 text-lg">
              Sentiremos sua falta. Por favor, nos informe seu nome.
            </p>
          </div>

          <form onSubmit={handleSubmitNaoPosso} className="space-y-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Nome *
              </label>
              <input
                type="text"
                value={dados.nome}
                onChange={(e) => setDados({ ...dados, nome: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-red-500 focus:outline-none text-lg"
                placeholder="Digite seu nome"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-2 text-lg">
                Sobrenome *
              </label>
              <input
                type="text"
                value={dados.sobrenome}
                onChange={(e) => setDados({ ...dados, sobrenome: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:border-red-500 focus:outline-none text-lg"
                placeholder="Digite seu sobrenome"
                required
              />
            </div>

            <div className="pt-4 space-y-3">
              <button
                type="submit"
                disabled={enviando}
                className="w-full bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 text-lg shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {enviando ? 'Enviando...' : 'Enviar'}
              </button>

              <button
                type="button"
                onClick={() => setEtapa('inicial')}
                className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-all text-lg"
              >
                Voltar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Tela de Sucesso
  if (etapa === 'sucesso') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-8 md:p-12 text-center">
          <div className="mb-6">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-12 h-12 text-green-500" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Recebido com sucesso! ✨
            </h2>
            <p className="text-gray-600 text-lg">
              {dados.status === 'confirmado' 
                ? 'Obrigado por confirmar! Estamos ansiosos para te ver no evento!'
                : 'Obrigado por nos avisar. Esperamos te ver em uma próxima oportunidade!'}
            </p>
          </div>

          {dados.status === 'confirmado' && (
            <div className="bg-purple-50 rounded-xl p-6 mb-6">
              <h3 className="font-semibold text-gray-800 mb-3 text-lg">Resumo da Confirmação:</h3>
              <div className="space-y-2 text-left">
                <p className="text-gray-700"><span className="font-semibold">Nome:</span> {dados.nome}</p>
                <p className="text-gray-700"><span className="font-semibold">Adultos:</span> {dados.adultos}</p>
                <p className="text-gray-700"><span className="font-semibold">Crianças:</span> {dados.criancas}</p>
                <p className="text-gray-700"><span className="font-semibold">Adolescentes:</span> {dados.adolescentes}</p>
                <p className="text-gray-700 font-semibold border-t pt-2 mt-2">
                  Total de pessoas: {dados.adultos + dados.criancas + dados.adolescentes}
                </p>
              </div>
            </div>
          )}

          <button
            onClick={() => {
              setEtapa('inicial');
              setDados({
                nome: '',
                sobrenome: '',
                adultos: 1,
                criancas: 0,
                adolescentes: 0,
                status: ''
              });
            }}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-8 rounded-xl transition-all text-lg"
          >
            Fazer Nova Resposta
          </button>
        </div>
      </div>
    );
  }
  // Tela de Lista de Presentes
if (etapa === 'lista-presentes') {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
        <div className="text-center mb-8">
          <Heart className="w-16 h-16 mx-auto text-blue-500 mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Sugestões de Presentes 🎁
          </h2>
          <p className="text-gray-600 text-lg mb-6">
            Aqui estão algumas ideias de presentes
          </p>
        </div>
            <div className="space-y-4 mb-8">
            {/* Lista de presentes - Aniversário de 1 ano */}
            <div className="bg-pink-50 rounded-xl p-4">
                <h3 className="font-semibold text-gray-800 mb-2">🧸 Brinquedos</h3>
                <p className="text-gray-600">
                Blocos de montar , brinquedos educativos ou musicais
                </p>
            </div>

            <div className="bg-pink-50 rounded-xl p-4">
                <h3 className="font-semibold text-gray-800 mb-2">👕 Roupinhas</h3>
                <p className="text-gray-600">
                Conjuntinhos, pijamas, tamanho  2 anos
                </p>
            </div>

            <div className="bg-pink-50 rounded-xl p-4">
                <h3 className="font-semibold text-gray-800 mb-2">👟 Calçados</h3>
                <p className="text-gray-600">
                Calçados tm 20-22
                </p>
            </div>




            </div>


        <button
          onClick={() => setEtapa('inicial')}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 text-lg shadow-lg"
        >
          Voltar
        </button>
      </div>
    </div>
  );
}
}